var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('admin-permanences-settings'),_c('admin-calendar-events-manual')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }